import { createSelector } from '@ngrx/store';

import { AcceptedResourceItemType } from '@models';

import { AppState } from './initial-state';

const selectListItems = (state: AppState) => state.list.items;
const selectListSelected = (state: AppState) => state.list.selected;

export const selectSelectedItems = createSelector(
  selectListSelected,
  (selected) => Object.values(selected)
);

const reuseUnchangedRows = () => {
  let previousRows = new Map<
    AcceptedResourceItemType,
    Selectable<AcceptedResourceItemType>
  >();

  return (
    items: AcceptedResourceItemType[],
    selected: AppState['list']['selected']
  ) => {
    const rows = new Map<
      AcceptedResourceItemType,
      Selectable<AcceptedResourceItemType>
    >();
    const result = items.map((item) => {
      const isSelected = !!selected[item.rid];
      const previousRow = previousRows.get(item);
      const row =
        previousRow?.selected === isSelected
          ? previousRow
          : { ...item, selected: isSelected };

      rows.set(item, row);

      return row;
    });

    previousRows = rows;

    return result;
  };
};

export const selectItemsWithSelected = createSelector(
  selectListItems,
  selectListSelected,
  reuseUnchangedRows()
);
